import {useState} from "preact/hooks";
import Menu from "../../containers/Menu/Menu";
import ListItem from "../list-item";
import Icon from "../Icon/Icon";
import { format, parseISO, isAfter, isToday, addMinutes, addHours, addYears } from "date-fns";

const ChatRestrictionSettings = ({ loading = false, restrictedUntil = '', onRestrict }) => {
  const [isMenuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    setMenuVisible(!isMenuVisible);
  };

  const onRequestRestrict = (v) => {
    onRestrict && onRestrict(v);
    setMenuVisible(false);
  };

  const date = parseISO(restrictedUntil);
  const isRestricted = restrictedUntil && isAfter(date, new Date());

  let title = "Canal aberto";
  if (isRestricted) {
    title = "Canal restrito até " + format(date, "HH:mm");
    if (!isToday(date)) {
      title += " do dia " + format(date, "dd/MM/yyyy");
    }
  }
  const subtitle = isRestricted ? "Somente moderadores podem enviar mensagens" : "Todos os membros pode enviar mensagens";
  const menuOptions = isRestricted ? [{label: "Liberar canal", onClick: () => onRequestRestrict('')}] : [
    {label: "Restringir por 10 minutos", onClick: () => onRequestRestrict(addMinutes(new Date(), 10).toISOString())},
    {label: "Restringir por 1 hora", onClick: () => onRequestRestrict(addHours(new Date(), 1).toISOString())},
    {label: "Restringir por 8 horas", onClick: () => onRequestRestrict(addHours(new Date(), 8).toISOString())},
    {label: "Restringir por 1 ano", onClick: () => onRequestRestrict(addYears(new Date(), 1).toISOString())},
  ];

  return <ListItem
      title={title}
      subtitle={subtitle}
      fadedSubtitle
      hoverFeedback
      loading={loading}
      style={{paddingLeft: 16, paddingRight: 16}}
      onClick={toggleMenu}
      right={
        <Menu options={menuOptions} isVisible={isMenuVisible} onClickOutside={() => setMenuVisible(false)}>
          <Icon name="chevron_down" />
        </Menu>
      } />;
};

export default ChatRestrictionSettings;



// WEBPACK FOOTER //
// ./components/ChatRestrictionSettings/ChatRestrictionSettings.js